import { useLang } from "../context/LanguageContext";
import { t } from "../data/translations";
import styles from "./Privacy.module.css";

const Privacy = () => {
  const { lang } = useLang();

  return (
    <div className={styles.container}>
      <h1>{t("privacy.title", lang)}</h1>
      <p>{t("privacy.lastUpdated", lang)}</p>

      <h2>{lang === "en" ? "1. Introduction" : "1. Εισαγωγή"}</h2>
      <p>{t("privacy.intro", lang)}</p>

      <h2>{t("privacy.cookiesTitle", lang)}</h2>
      <p>{t("privacy.cookiesText", lang)}</p>

      <h2>{t("privacy.analyticsTitle", lang)}</h2>
      <p>{t("privacy.analyticsText", lang)}</p>

      <h2>{t("privacy.dataTitle", lang)}</h2>
      <p>{t("privacy.dataText", lang)}</p>

      <h2>{t("privacy.contactTitle", lang)}</h2>
      <p>
        {t("privacy.contactText", lang)}{" "}
        <a href="mailto:info@myapple.gr">info@myapple.gr</a>.
      </p>
    </div>
  );
};

export default Privacy;
